<template>
  <v-app>
    <!-- <v-button @click="login()">login</v-button>
    <p>{{ isLogin }}</p> -->
    <Sidebar
      v-if="
        $router.currentRoute.name !== 'Login' &&
        $router.currentRoute.name !== 'Login' &&
        $router.currentRoute.name !== 'CreateLineOAaccount' &&
        $router.currentRoute.name !== 'thank' &&
        $router.currentRoute.name !== 'BillingPlan' &&
        $router.currentRoute.name !== 'ver2' &&
        $router.currentRoute.name !== 'googleLogin' &&
        $router.currentRoute.name !== 'facebookLogin'&&
        // LV2
        $router.currentRoute.name !== 'signUp' &&
        $router.currentRoute.name !== 'form' &&
        $router.currentRoute.name !== 'createBranch' &&
        $router.currentRoute.name !== 'theme' &&
        $router.currentRoute.name !== 'payment' &&
        $router.currentRoute.name !== 'addpoint' &&
        $router.currentRoute.name !== 'staff' &&
        $router.currentRoute.name !== 'Register' &&
        $router.currentRoute.name !== 'Reward' &&
        $router.currentRoute.name !== 'convertRate' &&
        $router.currentRoute.name !== 'Random' &&
        $router.currentRoute.name !== 'RandomCGS'
      "
    />
    <router-view />
    <BroadcastProgressPopup />
  </v-app>
</template>

<script>
import Sidebar from './components/Sidebar.vue'
import BroadcastProgressPopup from './components/BroadCast/BroadcastProgressPopup.vue'
export default {
  name: 'App',
  components: {
    Sidebar,
    BroadcastProgressPopup
  }
}
</script>

<style>
/* ป๊อปอัปที่มีช่องค้นหา: ยึดไว้ด้านบน รายชื่อสั้นลงแล้วป๊อปอัปไม่กระโดดหนีช่องที่กำลังพิมพ์ */
.dialog-pin-top {
  align-self: flex-start;
  margin-top: 64px;
}
/* Kanit-font.css */
@import url('https://fonts.googleapis.com/css2?family=Kanit:wght@400;500;700&display=swap');

@import url("https://fonts.googleapis.com/css2?family=Kanit&display=swap");
@import url('https://fonts.googleapis.com/css2?family=Mulish:wght@200;300;400;600;700;800&display=swap');

*,
.v-application {
  font-family: 'Kanit', sans-serif;
  font-style: normal;
}
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow-x: hidden;
}
:root {
  --nav-bg: #1b437c;
  --nav-text: #ffffff;
  --nav-text-active: #173053;
  --panel-bg: #173053;
  --panel-text: #ffffff;
  --table-body-row-even: #b1c9ea;
  --table-body-row-odd: #ffffff;
  --table-body-text: #1b437c;
  --btn-general-color: #ffffff;
}
.v-btn:focus {
  outline: none;
}
.theme--light.v-messages {
  color: rgba(0, 0, 0, 0.6);
}
.v-label {
  font-size: 14px !important;
  font-family: "Kanit", sans-serif;
}
.KittithadaBold {
  font-family: "Kanit", sans-serif;
  font-weight: 400;
}
h1 {
  font-family: 'Kanit', sans-serif;
  /* font-family: "Kanit", sans-serif; */
  font-size: 32px !important;
}
h2 {
  font-family: 'Kanit', sans-serif;
  /* font-family: 'Kanit', sans-serif; */
  font-size: 24px !important;
}
h3 {
  font-family: 'Kanit', sans-serif;
  font-size: 18.72px !important;
}
h4 {
  font-family: 'Kanit', sans-serif;
  /* font-family: "Kanit", sans-serif; */
  font-size: 16px !important;
}
h5 {
  font-family: 'Kanit', sans-serif;
  /* font-family: "Kanit", sans-serif; */
  font-size: 13.28px !important;
}
h6 {
  font-family: 'Kanit', sans-serif;
  /* font-family: "Kanit", sans-serif; */
  font-size: 10.72 !important;
}
.nav-bg {
  background-color: var(--nav-bg) !important;
}
.bar {
  fill: var(--nav-bg);
}
.grid {
  fill: none;
  stroke: #444;
  stroke-width: 1.5px;
}
/* .chartHead {
  font-size: 1.65rem !important;
  font-weight: 400;
  letter-spacing: 0.0125em !important;
} */
.v-navigation-drawer .v-list {
  padding: 0px !important;
}
.nav-text-active {
  /* color: var(--nav-text-active) !important; */
}
.nav-text {
  color: var(--nav-text) !important;
}
.v-application a {
  color: var(--nav-bg) !important;
}
.v-toolbar__content {
  justify-content: space-around;
}
.theme--light.v-btn.v-btn--has-bg {
  background-color: var(--nav-bg);
}
.v-navigation-drawer__content {
  background-color: var(--nav-bg);
}
.v-application--is-ltr
  .v-list-group--no-action
  > .v-list-group__items
  > .v-list-item {
  padding-left: 45px !important;
}
.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 15px !important;
}
.v-list-item__title {
  color: var(--nav-text) !important;
  font-family: "Kanit", sans-serif;
  font-weight: 400;
}
.v-select-list {
  background-color: var(--nav-bg) !important;
}
.v-simple-checkbox .v-icon {
  cursor: pointer !important;
  /* color: rgb(255, 255, 255) ; */
}
.v-input--selection-controls__input > .v-icon {
  color: var(--nav-bg);
}
.v-date-picker-header {
  background-color: var(--date-picker-head);
}
.v-date-picker-table {
  background-color: var(--date-picker-head);
}
.v-date-picker-table > table > thead {
  background-color: var(--date-picker-table-head);
}
.v-date-picker-table > table > tbody {
  background-color: var(--date-picker-table-body);
}
*/ .v-list-group__header {
  background-color: var(--nav-bg) !important;
}
.menu-head {
  color: var(--nav-text);
  font-family: "Kanit", sans-serif;
  font-weight: 400;
}
.v-list-item--active {
  background-color: var(--nav-text-active);
}
.theme--light.v-list-item:not(.v-list-item--active):not(
    .v-list-item--disabled
  ) {
  background-color: var(--nav-bg) ;
}
.theme--light.v-app-bar.v-toolbar.v-sheet {
  background-color: var(--nav-bg) !important;
  color: var(--nav-text) !important;
}
.v-expansion-panel-header {
  font-weight: bold;
}
.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 48px;
}
.v-breadcrumbs {
  font-weight: bold;
}
.v-data-table-header {
  background-color: var(--table-head-bg) !important;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: var(--table-head-text) !important;
}
/* .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 0px 5px 0px 15px;
} */
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  color: var(--table-body-text) !important;
}
.custom_table_class thead th:first-child {
  border-radius: 10px 0 0 0;
}
.custom_table_class thead th:last-child {
  border-radius: 0 10px 0 0;
}
.theme--light.v-data-table .v-data-table-header th.sortable.active,
.theme--light.v-data-table
  .v-data-table-header
  th.sortable.active
  .v-data-table-header__icon,
.theme--light.v-data-table .v-data-table-header th.sortable:hover {
  color: var(--table-head-text) !important;
}
.theme--light.v-data-table
  .v-data-table-header
  th.sortable
  .v-data-table-header__icon {
  color: var(--table-head-text) !important;
}
.btn {
  color: var(--btn-general-color);
}
.nav-button {
  color: var(--nav-text);
  background-color: var(--nav-bg);
}
.nav-button-dark {
  color: var(--nav-text);
  background-color: #173053;
}
.v-navigation-drawer__append {
  background-color: #173053;
}
.shopname {
  font-size: 26px !important;
  font-weight: bold;
}
.theme--light.v-card {
  border-radius: 0px;
}
.v-card__subtitle,
.v-card__text,
.v-card__title {
  padding: 0px !important;
}
.v-text-field {
  padding: 16px;
}
.v-card_color {
  background-color: var(--nav-text-active);
  width: 350px;
  height: 600px;
}
.v-margit_button {
  margin-top: 15px;
}
.v-margit_button_right {
  margin-top: -8px;
}
.v-margit_img {
  margin-top: 150px;
}
.v-margit_img_reward {
  margin-top: 20px;
}
.v-margit_text_add {
  margin-top: 10px;
}
.v_text_add {
  color: var(--nav-text-active);
  width: 170px;
  height: 50px;
}
.v_text_edit {
  width: 255px;
  height: 52px;
}
.v-img-margit {
  width: 128.19px;
  height: 84px;
}
.v-img-D {
  size: 26px !important;
  width: 100px;
  height: 60px;
}
.v-img-next {
  height: 100px;
  width: 135px;
}
.v-img-rental {
  height: 160px;
  width: 104px;
}
.v_text_new {
  height: 43px;
  width: 174px;
}
.underline-06 {
  background-image: linear-gradient(90deg, #e67399, #f2a640);
  background-position: bottom;
  background-size: 100% 10%;
  background-repeat: no-repeat;
}
.c3-axis-y-label,
.c3-axis-x-label,
.c3-chart-arcs-gauge-min,
.c3-chart-arcs-gauge-max {
  font-size: 17px !important;
}
.theme--light.v-calendar-weekly .v-calendar-weekly__day {
  border-right: 2px solid #555 !important;
  border-bottom: 2px solid #555 !important;
  color: #000 !important;
}
.v-label {
  margin-bottom: 0;
  font-weight: bold;
}
v-btn .btnEdit {
  background-color: #5c99db !important;
}
::-webkit-scrollbar {
    display: none;
}
/* css by champ */
@media only screen and (max-width: 768px) {
.btn-all {
  border-radius: 20px;
  height: 24px;
}
}

.col-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    gap: 16px;
  }

  .btn-grid {
    grid-column: -1;
    justify-self: stretch;
  }

  @media screen and (max-width: 768px) {
    .btn-grid {
      grid-column: auto;
      justify-self: center;
      justify-self: stretch;
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue